import _cloneDeep from "lodash/cloneDeep";
import { BaseServiceRequestPayload } from "../types";

// Builds the request body for the Call OEM partial save by merging customerCalledOem: true
// into a clone of the existing serviceRequestPayload. This flag is only ever set true on this
// specific partial save — it is never sent on the odometer or decline partial saves.
export function buildCallOemPartialSavePayload(
  serviceRequestPayload: BaseServiceRequestPayload
): BaseServiceRequestPayload {
  const clonedPayload = _cloneDeep(serviceRequestPayload);
  return {
    ...clonedPayload,
    customerCalledOem: true,
  };
}
